<!-- src/views/About.vue -->
<!-- eslint-disable -->
<template>
  <div class="container">

    <div class="dropdown-container">
      <label for="trackDataSelector">Select Track Data:</label>
      <select id="trackDataSelector" v-model="selectedTrackData">
        <option value="CSVC_trial">CSVC_trial</option>
        <option value="trial_trackdata">Trial_trackdata</option>
        <option value="trackdata">Trackdata</option>
        <option value="testout">testout</option>
        <option value="dev2_trackdata">Dev2 Trackdata</option>
      </select>
    </div>

    <div class="container-box">
      <StopSearch />
    </div>

    <div class="horiz-container">
      <div class="stopspanel">
        <div class="selection-controls">
          <button 
            @click="stateData.isAreaSelectionMode.value = !stateData.isAreaSelectionMode.value" 
            :class="['action-btn', { active: stateData.isAreaSelectionMode.value }]"
            title="Select area on map to see average routes"
          >
            {{ stateData.isAreaSelectionMode.value ? 'Cancel Selection' : 'Select Area (Avg Routes)' }}
          </button>
          <button 
            v-if="stateData.areaLayerGroup.getLayers().length > 0"
            @click="stateData.areaLayerGroup.clearLayers()" 
            class="action-btn clear"
          >
            Clear Selection Results
          </button>
        </div>
        <StopPanel />
      </div>
      <div class="events-map">
        <Map />
      </div>
    </div>

  </div>
</template>


<script setup>
/* eslint-disable */
import { provide, ref, watch, onMounted } from 'vue';
import Map from '../components/Map.vue';
import StopSearch from '../components/StopSearch.vue';
import StopPanel from '../components/StopPanel.vue';
import State_StopData from '../statedata/state_stopdata'
import DBData from '../dbdata'

const selectedTrackData = ref('testout');
const trackDataProvider = ref(new DBData({ dbname: selectedTrackData.value }))

const stateData = new State_StopData({db: trackDataProvider});

provide('stateData', stateData);
provide('datastore', stateData);

onMounted(async () => {
  console.log('StopTrackingPage: onMounted - Initializing spatial data');
  await stateData.initSpatialData();
});

watch(selectedTrackData, async (newValue, oldValue) => {
  console.log(`StopTrackingPage: selectedTrackData changed from [${oldValue}] to [${newValue}]`);
  if (newValue !== oldValue) {
    trackDataProvider.value = new DBData({ dbname: newValue });
    await stateData.initSpatialData();
  }
});

</script>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: 100%;
  height: 100%;
}

.events-map {
  flex: 1;
}

.horiz-container {
  display: flex;
  flex-direction: row;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  background: #1a1a1a;
  gap: 0px;
  width: 100%;
  height: 100%;
  min-height: 100px;
  box-sizing: border-box;
}

.stopspanel {
  width: 350px;
  border-right: 1px solid rgba(255, 255, 255, 0.1);
  background: #121212;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.selection-controls {
  padding: 1rem;
  display: flex;
  gap: 0.5rem;
  flex-direction: column;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.action-btn {
  padding: 0.6rem 1rem;
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.05);
  color: #fff;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  backdrop-filter: blur(5px);
  text-align: center;
  font-size: 0.85rem;
}

.action-btn:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.2);
}

.action-btn.active {
  background: rgba(76, 175, 80, 0.2);
  border-color: #4caf50;
  color: #4caf50;
}

.action-btn.clear {
  background: rgba(244, 67, 54, 0.1);
  border-color: rgba(244, 67, 54, 0.3);
  color: #f44336;
}

.action-btn.clear:hover {
  background: rgba(244, 67, 54, 0.2);
}
</style>
